//计算属性
export default{
	  systemData: state => {
	      return state.systemData
	    },
		Login: state=>{
			return state.Login
		},
		Query: state=>{
			return state.Query
		},
		Search: state=>{
			return state.Search
		},
		Icon: state=>{
			return state.Icon
		},
		Router: state=>{
			return state.Router
		},
LoanInfos:state=>{
	return state.LoanInfos
},
ShowLoanInfo:state=>{
	return state.ShowLoanInfo
},
	CompanyName:state=>{
		return state.CompanyName
	}	
}


// WEBPACK FOOTER //
// ./src/store/getters.js